import auth from "./auth";

export interface Device {
  id: string;
  token: string;
  userId: string;
  roonPlatform: string;
  roonVersion: string;
  roonProduct: string;
  language: string;
}

async function registerDevice(device: Device) {
  await auth.authenticateRequest("post", "/2/api/devices", device);
}

export default {
  registerDevice,
};
